<template>
  <div
    class="business-content-main"
    v-loading="loading"
    element-loading-spinner="none"
  >
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true"></breadcrumb>
    </div>
    <div class="search-ctn">
      <div class="search-ctn-left">
        <div class="search-name">扫码</div>
        <el-input
          ref="inputdata"
          v-model="scanData"
          clearable
          placeholder="请扫描组装单码或商品标签"
          size="small"
          style="width: 250px"
          @blur="inputblur()"
          @change="inputDataChange()"
        ></el-input>
        <el-button size="small" class="search-btn btn-primary" @click="submit()"
          >提交出仓</el-button
        >
        <div class="search-name" v-if="orderCode">
          组装单号：{{ orderCode }}
        </div>
        <div class="search-name" style="color: red">
          （请先扫组装单，后扫商品标签。确保焦点在标签输入框内，并检查电脑的输入法是否英文输入）
        </div>
      </div>
    </div>
    <div>
      <el-row :gutter="20" class="table-ctn">
        <el-col :span="12">
          <div class="grid-content">
            <el-table
              :header-cell-style="{ background: '#F2F6FC' }"
              border
              :data="dataList"
              style="width: 100%"
              empty-text="请扫描组装单上的二维码"
            >
              <el-table-column
                label="汽配编码"
                show-overflow-tooltip
                min-width="100px"
                prop="APCode"
              ></el-table-column>
              <el-table-column
                label="汽配名称"
                show-overflow-tooltip
                min-width="100px"
                prop="GoodName"
              ></el-table-column>
              <el-table-column
                label="适用车型"
                show-overflow-tooltip
                min-width="100px"
                prop="AutoSerise"
              ></el-table-column>
              <el-table-column
                label="单包需求"
                show-overflow-tooltip
                width="80px"
                prop="OrderNeedCount"
              ></el-table-column>
              <el-table-column
                label="已组数量"
                show-overflow-tooltip
                width="80px"
                prop="PackedCount"
              ></el-table-column>
              <el-table-column
                label="待组数量"
                show-overflow-tooltip
                width="80px"
              >
                <template slot-scope="scope">
                  <div
                    :class="{
                      'check-class': scope.row.Count > 0,
                    }"
                  >
                    {{ scope.row.Count }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="扫码数量"
                show-overflow-tooltip
                width="80px"
              >
                <template slot-scope="scope">
                  <div
                    :class="{
                      'check-class-enough':
                        scope.row.Count - scope.row.ScanCount == 0 &&
                        scope.row.ScanCount > 0,
                    }"
                  >
                    {{ scope.row.ScanCount }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content">
            <div class="labelzone">
              <el-card
                class="box-card"
                v-for="(item, index) in cardList"
                :key="index"
              >
                <div style="padding: 14px">
                  <span class="goodname">{{ item.GoodName }}</span>
                  <div class="bottom clearfix">
                    <span class="apcode">{{ item.APCode }}</span>
                    <span class="button">
                      {{ item.PackingSpec + " " + item.Unit }}
                    </span>
                  </div>
                  <div class="bottom clearfix">
                    <time class="time">{{ item.LabelCode }}</time>
                    <el-button
                      type="text"
                      class="button"
                      icon="el-icon-delete"
                      style="color: red"
                      @click="delItem(item)"
                    ></el-button>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </el-col>
      </el-row>
      <audio ref="audio" controls hidden></audio>
      <el-dialog
        :close-on-click-modal="false"
        title="打印组装单套包商品标签"
        :visible.sync="showPrintOrderDialog"
        width="1200px"
      >
        <div class="dialog-content" v-if="showPrintOrderDialog">
          <printGoodsLabels
            @closeDialog="closePrintLabelsDialog"
            :SetOrderId="orderId"
          ></printGoodsLabels>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import printGoodsLabels from "@/components/business/goods/printSetOrderLabels.vue";
export default {
  name: "OrderScan",
  components: {
    breadcrumb,
    printGoodsLabels,
  },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      stype: 0,
      loading: false,
      userMsg: userMsg,
      oid: "",
      orderId: "",
      dataList: [],
      scanData: "",
      labels: [],
      cardList: [],
      orderCode: "",
      firstScanOrder: true,
      currectAudio: "/download/currect.mp3",
      errorAudio: "/download/error.mp3",
      allOutAudio: "/download/allout.mp3",
      wrongXSAudio: "/download/wrongxs.mp3",
      repetLabel: "/download/repetlabel.mp3",
      enoughAudio: "/download/enough.mp3",
      delAudio: "/download/del.mp3",
      cancelAudio: "/download/cancel.mp3",
      showPrintOrderDialog: false,
      isNeedFocus: true,
      isAutoSubmit: false
    };
  },
  mounted() {
    this.stype = this.$route.query.stype;
    if (this.stype == 1) {
      this.oid = this.$route.query.SetOrderId;
      this.getOrderDetail("", this.oid);
    }
    this.inputblur();
    this.getAutoSubmit();
  },
  methods: {
    getOrderDetail(orderCode, orderId) {
      let that = this;
      that.$util
        .axiosGet({
          url: "/api/EntpGoods/GetEnterpriseSetOrderToScanOut",
          data: {
            SetOrderId: orderId,
            SetOrderCode: orderCode,
            EntpId: that.userMsg.EntpId,
          },
        })
        .then((res) => {
          let data = res.data;
          if (data.State == 0) {
            that.firstScanOrder = true;
            that.aplayAudio(that.errorAudio);
            that.$util.warningMsg("提醒：组装单未提交");
            that.dataList = [];
            that.oid = "";
            that.orderId = "";
            return;
          }
          if (data.State == 2) {
            that.firstScanOrder = true;
            that.aplayAudio(that.errorAudio);
            that.$util.warningMsg("提醒：组装单已被删除");
            that.dataList = [];
            that.oid = "";
            that.orderId = "";
            return;
          }
          if (data.State == 3) {
            that.firstScanOrder = true;
            that.aplayAudio(that.errorAudio);
            that.$util.warningMsg("提醒：组装单已全部备货完成");
            that.oid = "";
            that.orderId = "";
            return;
          } 
          if (data.State == 4) {
            that.firstScanOrder = true;
            that.aplayAudio(that.errorAudio);
            that.$util.warningMsg("提醒：组装单已被取消");
            that.dataList = [];
            that.oid = "";
            that.orderId = "";
            return;
          }          
          that.dataList = [];
          that.orderId = data.SetOrderId;
          that.orderCode = data.SetOrderCode;
          let DetailList = data.DetailList;
          for (let i = 0; i < DetailList.length; i++) {
            that.dataList.push({
              APCode: DetailList[i].APCode,
              GoodName: DetailList[i].GoodName,
              Unit: DetailList[i].Unit,
              AutoSerise: DetailList[i].AutoSerise,
              Count: DetailList[i].Count,
              OrderNeedCount: DetailList[i].OrderNeedCount,
              PackedCount: DetailList[i].PackedCount,
              ScanCount: 0,
              SortField: 0,
            });
          }
        }).catch(()=>{});
    },
    // 失去焦点
    inputblur() {
      let that = this;
      // FireFox 和 IE 失去焦点，blur直接执行focus 不会生效，加个延时
      if (this.isNeedFocus) {
        setTimeout(() => {
          if(that.$refs.inputdata)
              that.$refs.inputdata.focus();
        }, 100);
      }
    },
    inputDataChange() {
      let that = this;
      if (that.scanData.indexOf("ZZ") > -1) {
        that.orderCode = that.scanData;
        if (that.firstScanOrder) {
          if (that.scanData.length == 17) {
            that.firstScanOrder = false;
            that.getOrderDetail(that.scanData, "");
          } else {
            that.aplayAudio(that.errorAudio);
            that.$util.warningMsg("组装单号长度不符合规则！请检查输入法是否为英文输入法");
          }
        } else {
          that
            .$confirm("已经有未提交出仓组装单，是否确定放弃提交？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              center: false,
            })
            .then(() => {
              that.firstScanOrder = true;
              that.labels = [];
              that.cardList = [];
              that.dataList = [];
              this.getOrderDetail(that.orderCode, "");
            })
            .catch(() => {});
        }
      } else if (that.scanData.indexOf("AP-") > -1) {
        if (that.scanData.length == 20) {
          that.$util
            .axiosGet({
              url: "/api/EntpGoods/CheckEntpSetOrderGoods",
              data: {
                EntpId: that.userMsg.EntpId,
                SetOrderId: that.orderId,
                LabelCode: that.scanData,
              },
            })
            .then((res) => {
              let data = res.data;
              if (data) {
                let datalist = that.dataList;
                var label = {
                  APCode: data.APCode,
                  GoodName: data.GoodName,
                  PackingSpec: data.PackingSpec,
                  LabelCode: data.LabelCode,
                  Unit: data.Unit,
                  LabelId: data.LabelId,
                };
                var isRepet = false;
                if (that.cardList.length > 0) {
                  that.cardList.forEach((element) => {
                    if (element.LabelCode == label.LabelCode) {
                      isRepet = true;
                      that.$util.warningMsg("重复标签！");
                      return;
                    }
                  });
                }
                if (isRepet) {
                  that.aplayAudio(that.repetLabel);
                  return;
                }

                if (datalist && datalist.length > 0) {
                  let isEnoughSubmit = true;
                  let PackingSpec=label.PackingSpec;
                  let targetList=datalist.filter(e=>e.APCode==label.APCode);
                  let needCount=targetList.reduce((prev,curr)=>{return prev+Number(curr.Count)},0);
                  let sCount=targetList.reduce((prev,curr)=>{return prev+Number(curr.ScanCount)},0);

                  if(sCount+PackingSpec>needCount){
                    that.aplayAudio(that.enoughAudio);
                    that.$util.warningMsg("标签的商品总数大于组装待出的数量！");
                    return;
                  }
                  that.cardList.push(label);
                  that.labels.push(data.LabelId);    
                  //排除已完成的
                  targetList=datalist.filter(e=>e.APCode==label.APCode&&e.ScanCount!=e.Count);
                  targetList.forEach((e,i)=>{
                    let dif=e.Count-e.ScanCount;
                    if(dif>=PackingSpec){
                       e.ScanCount+=PackingSpec;
                       PackingSpec=0;
                    }else if(dif<PackingSpec){
                       PackingSpec-=dif;
                       e.ScanCount+=dif;
                    }

                    e.SortField =
                      e.Count -e.ScanCount == 0 &&
                      e.ScanCount > 0
                        ? 1
                        : 0;

                    if(PackingSpec==0)return; 
                  });

                  datalist.sort(function (a, b) {
                    return a.SortField - b.SortField;
                  });

                  that.aplayAudio(that.currectAudio);
                  //判断组包的商品已经扫够，如果刚好够的话，自动提交
                  if (that.isAutoSubmit) {
                    datalist.forEach((e)=>{
                      if(e.ScanCount!=e.Count){
                        isEnoughSubmit=false;
                        return;
                      }
                    });
                    if (isEnoughSubmit) that.submit();
                  } 
                }
              } else {
                that.aplayAudio(that.errorAudio);
              }
            })
            .catch(() => {
              that.aplayAudio(that.errorAudio);
            });
        } else if (that.scanData.length != 0) {
          that.aplayAudio(that.errorAudio);
          that.$util.warningMsg("标签码长度不符合规则！请检查输入法是否为英文输入法");
        }
      } else {
        that.$util.warningMsg("请检查是否按要求操作，确认后重新提交");
      }
      that.scanData = "";
    },
    delItem(item) {
      let that = this;
      if (item) {
        this.cardList.splice(this.cardList.indexOf(item), 1);
        this.labels.splice(this.labels.indexOf(item.LabelId), 1);
        let datalist = that.dataList;
        if (datalist && datalist.length > 0) {
          let PackingSpec=item.PackingSpec;
          let targetList=datalist.filter(e=>e.APCode==item.APCode&&e.ScanCount>0);
          if(targetList.length>0){
            targetList.forEach((e,i)=>{
              if(e.ScanCount>PackingSpec){
                e.ScanCount-=PackingSpec;
                PackingSpec=0;
              }else if(e.ScanCount<PackingSpec){
                PackingSpec-=e.ScanCount;
                e.ScanCount=0;
              }else{
                 e.ScanCount=0;
                 PackingSpec=0;
              }
              e.SortField =
                e.Count -e.ScanCount == 0 &&
                e.ScanCount > 0
                  ? 1
                  : 0;

                if(PackingSpec==0)return;  
            });
              datalist.sort(function (a, b) {
                return a.SortField - b.SortField;
              });
              that.dataList = datalist;            
          }
        }
      }
    },
    submit() {
      let that = this;
      if (that.labels.length == 0) {
        that.$util.warningMsg("无标签信息，请重新扫码");
        return;
      }
      let datalist = that.dataList;
      if (datalist && datalist.length > 0) {
        let scount = 0;
        let needCount = 0;
        for (let i = 0; i < datalist.length; i++) {
          0;
          scount = datalist[i].ScanCount;
          needCount = datalist[i].Count;
          if (scount != needCount) {
            that.aplayAudio(that.errorAudio);
            that.$util.warningMsg(
              "所扫的商品标签数还不够整单组装！请确认后重新操作"
            );
            return;
          }
        }
      } else {
        that.$util.warningMsg("提交的数据异常，请刷新重新操作");
        return;
      }

      that
        .$confirm("确定提交组装出仓吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: false,
        })
        .then(() => {
          this.loading = true;
          this.$util
            .axiosPost({
              url: "/api/EntpGoods/EntpScanLabelSetOrderOutStorage",
              data: {
                EntpId: that.userMsg.EntpId,
                StaffId: that.userMsg.EmployeeId,
                SetOrderId: that.orderId,
                LabelIdList: that.labels,
              },
            })
            .then((res) => {
              if (res.errcode == 0) {
                that.$util.successMsg("备货成功");
                that.firstScanOrder = true;
                that.labels = [];
                that.cardList = [];
                that.loading = false;

                //这里要弹出打印标签弹出层
                that.showPrintLabelsDialog(that.orderId);
              } else {
                that.$util.successMsg(res.errmsg);
              }
            })
            .catch(() => {
              that.loading = false;
            });
        }).catch(() =>{});
    },
    aplayAudio(audioUrl) {
      this.$refs.audio.src = audioUrl;
      this.$nextTick((res) => {
        this.$refs.audio.load();
        this.$refs.audio.play();
      });
    },
    closePrintLabelsDialog() {
      this.showPrintOrderDialog = false;
      this.isNeedFocus = true;
    },
    showPrintLabelsDialog(orderId) {
      if (orderId) {
        this.isNeedFocus = false;
        this.showPrintOrderDialog = true;
      }
    },
    getAutoSubmit() {
      this.$util.getSysConfig("smzdtj").then(res => {
        this.isAutoSubmit = res.Result;
      });
    }    
  },
};
</script>
<style lang="less" scoped>
.labelzone {
  display: flex;
  flex-wrap: wrap-reverse;
  padding-left: 20px;
  width: 100%;
  height: 100%;
  margin-bottom: 30px;
}
.labelk {
  display: flex;
  flex-direction: column;
}
.box-card {
  width: 220px;
  margin: 5px;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.goodname {
  font-size: 18px;
  line-height: 24px;
}
.apcode {
  font-size: 15px;
}
.check-class {
  color: red;
  font-weight: bold;
}
.check-class-enough {
  color: green;
  font-weight: bold;
}
</style>
